import Component from 'flarum/common/Component';
import { FORMATIONS } from '../utils/formations';
import { getSquad } from '../utils/squadApi';
export default class LineupPitch extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.squad = null;
    this.players = this.parsePlayers(this.attrs.players);
    this.formation = this.attrs.formation || '4-4-2';
    getSquad().then(data => {
      this.squad = data;
      m.redraw();
    });
  }
  parsePlayers(text) {
    if (!text) return {};
    const groups = {};
    const lines = text.split('\n');
    for (const line of lines) {
      const match = line.match(/^\s*(MV|FB|MF|AF)\s*:\s*(.+)/i);
      if (match) {
        const key = match[1].toLowerCase();
        const names = match[2].split(',').map(n => n.trim()).filter(Boolean);
        groups[key] = names;
      }
    }
    return groups;
  }
  findPlayerNumber(name) {
    if (!this.squad) return null;
    for (const group of ['mv', 'fb', 'mf', 'af']) {
      const players = this.squad[group] || [];
      const found = players.find(p => p.name && p.name.toLowerCase() === name.toLowerCase());
      if (found && found.number) return found.number;
    }
    return null;
  }
  view() {
    const formation = this.attrs.formation || this.formation;
    const players = this.parsePlayers(this.attrs.players);
    const formationDef = FORMATIONS[formation];
    if (!formationDef) {
      return m('.ois-lineup-fallback', [m('strong', formation), m('pre', this.attrs.players)]);
    }
    const slots = formationDef.slots;
    const groupCounters = {};
    const playerNodes = slots.map((slot, i) => {
      const gIdx = groupCounters[slot.group] || 0;
      groupCounters[slot.group] = gIdx + 1;
      const names = players[slot.group] || [];
      const name = names[gIdx] || '';
      const number = name ? this.findPlayerNumber(name) : null;
      const displayName = name ? name.split(' ').pop() : '';
      return m('.ois-lineup-player', {
        key: 'player-' + i,
        style: {
          left: slot.x + '%',
          bottom: slot.y + '%'
        }
      }, [m('.ois-lineup-dot', number || (displayName ? displayName.charAt(0) : '?')), name ? m('.ois-lineup-name', displayName) : null]);
    });
    return m('.ois-lineup-pitch', [m('.ois-lineup-field', [
    // Pitch markings
    m('.ois-lineup-halfway', {
      key: 'halfway'
    }), m('.ois-lineup-center-circle', {
      key: 'circle'
    }), m('.ois-lineup-center-dot', {
      key: 'dot'
    }), m('.ois-lineup-penalty-area.ois-lineup-penalty-area--bottom', {
      key: 'pen-bot'
    }), m('.ois-lineup-penalty-area.ois-lineup-penalty-area--top', {
      key: 'pen-top'
    }), m('.ois-lineup-goal-area.ois-lineup-goal-area--bottom', {
      key: 'goal-area-bot'
    }), m('.ois-lineup-goal-area.ois-lineup-goal-area--top', {
      key: 'goal-area-top'
    }), m('.ois-lineup-goal.ois-lineup-goal--bottom', {
      key: 'goal-bot'
    }), m('.ois-lineup-goal.ois-lineup-goal--top', {
      key: 'goal-top'
    }),
    // Players
    ...playerNodes]), m('.ois-lineup-formation-label', this.formation)]);
  }
}
flarum.reg.add('ois-lineup', 'forum/components/LineupPitch', LineupPitch);